<script>
  import { getContext } from 'svelte'
  import { area } from 'd3-shape'
  export let scale
  export let stroke = 'none'
  export let strokeWidth = 0
  export let fill = '#f2f2f2'
  export let values
  export let height, width
  export let data

  let { nData, margin } = getContext('chart')

  $: area_gen = area()
    .x((d) => scale.x(d[values.x]))
    .y0(height - margin.bottom)
    .y1((d) => scale.y(d[values.y]))
</script>

<path
  class="chart-area-one"
  style="stroke: {stroke}; stroke-width: {strokeWidth}px; fill: {fill};"
  d={area_gen(data)}
/>
